import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "@app/environment";

import { StorageObjectList } from "../models/bucket.model";

@Injectable({ providedIn: 'root' })
export class BucketEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        participationPhotos: `${environment.bucketOrigin}/storage/v1/b/${environment.participationPhotoBucketName}/o`,
        participationPhoto: `${environment.bucketOrigin}/${environment.participationPhotoBucketName}`
    };

    getParticipationStorageObjects(participationId: string): Observable<StorageObjectList> {
        return this.http.get<StorageObjectList>(this.endpoints.participationPhotos, {
            params: { prefix: participationId.toUpperCase(), projection: 'noAcl' }
        });
    }

    getParticipationImageLink(objectName: string): string {
        return `${this.endpoints.participationPhoto}/${objectName}`;
    }

    getParticipationPhotoLink(participationId: string, fileName: string): string {
        return this.getParticipationImageLink(`${participationId.toUpperCase()}/${fileName}`);
    }
}
